// Definir el tipo de estructura para los colores
interface ColorTheme {
  BASE: string
  PRIMARY_BACKGROUND: string
  ACCENT: string
  SECONDARY_MAIN: string
  WHITE: string
  LIGHT_GREY: string
  GRAY: string
  DARK_GREY: string
}

// Definir los temas de colores
const COLOR_THEMES: Record<string, ColorTheme> = {
  tea: {
    BASE: '#27352e',
    PRIMARY_BACKGROUND: 'rgb(245, 246, 248)',
    ACCENT: '#efefef',
    SECONDARY_MAIN: '#27352e',
    WHITE: '#fff',
    LIGHT_GREY: '#efefef',
    GRAY: 'rgba(0, 0, 0, 0.54)',
    DARK_GREY: '#2E2E2E',
  },
  ge: {
    BASE: '#E78923',
    PRIMARY_BACKGROUND: 'rgb(245, 246, 248)',
    ACCENT: '#275E56',
    SECONDARY_MAIN: '#275E56',
    WHITE: '#fff',
    LIGHT_GREY: '#efefef',
    GRAY: 'rgba(0, 0, 0, 0.54)',
    DARK_GREY: '#2E2E2E',
  },
  'le-pain-quotidien': {
    BASE: '#FDC400',
    PRIMARY_BACKGROUND: '#FBF5EE',
    ACCENT: '#FBF5EE',
    SECONDARY_MAIN: '#FDC400',
    WHITE: '#fff',
    LIGHT_GREY: '#F2E6D9',
    GRAY: 'rgba(0, 0, 0, 0.54)',
    DARK_GREY: '#4E342E',
  },
  cs: {
    BASE: '#848624',
    PRIMARY_BACKGROUND: '#eaeae2',
    ACCENT: '#18231D',
    SECONDARY_MAIN: '#275E56',
    WHITE: '#fff',
    LIGHT_GREY: '#efefef',
    GRAY: 'rgba(0, 0, 0, 0.54)',
    DARK_GREY: '#2E2E2E',
  },
  paru: {
    BASE: '#15182D',
    PRIMARY_BACKGROUND: '#EDEDEF',
    ACCENT: '#EDEDEF',
    SECONDARY_MAIN: '#030B21',
    WHITE: '#fff',
    LIGHT_GREY: '#efefef',
    GRAY: 'rgba(0, 0, 0, 0.54)',
    DARK_GREY: '#2E2E2E',
  },
  jb: {
    BASE: '#080808',
    PRIMARY_BACKGROUND: '#ebebe1',
    ACCENT: '#18231D',
    SECONDARY_MAIN: '#030B21',
    WHITE: '#fff',
    LIGHT_GREY: '#efefef',
    GRAY: 'rgba(0, 0, 0, 0.54)',
    DARK_GREY: '#2E2E2E',
  },
  ts: {
    BASE: '#50c9b5',
    PRIMARY_BACKGROUND: '#b68356',
    ACCENT: '#b68356',
    SECONDARY_MAIN: '#030B21',
    WHITE: '#fff',
    LIGHT_GREY: '#efefef',
    GRAY: 'rgba(0, 0, 0, 0.54)',
    DARK_GREY: '#2E2E2E',
  },
  ronnie: {
    BASE: '#FCBF00',
    PRIMARY_BACKGROUND: '#FBFBFB',
    ACCENT: '#000000',
    SECONDARY_MAIN: '#000000',
    WHITE: '#fff',
    LIGHT_GREY: '#efefef',
    GRAY: 'rgba(0, 0, 0, 0.54)',
    DARK_GREY: '#2E2E2E',
  },
  cm: {
    BASE: '#010101',
    PRIMARY_BACKGROUND: '#E0E0E0',
    ACCENT: '#FFFFFF',
    SECONDARY_MAIN: '#010101',
    WHITE: '#fff',
    LIGHT_GREY: '#efefef',
    GRAY: 'rgba(0, 0, 0, 0.54)',
    DARK_GREY: '#2E2E2E',
  },
  vicolo: {
    BASE: '#919145',
    PRIMARY_BACKGROUND: '#EFE4CE',
    ACCENT: '#FFFFFF',
    SECONDARY_MAIN: '#010101',
    WHITE: '#fff',
    LIGHT_GREY: '#efefef',
    GRAY: 'rgba(0, 0, 0, 0.54)',
    DARK_GREY: '#2E2E2E',
  },
  'signora-mariola': {
    BASE: '#1D1D1B',
    PRIMARY_BACKGROUND: '#FEF9F4',
    ACCENT: '#EFE4CE',
    SECONDARY_MAIN: '#1D1D1B',
    WHITE: '#fff',
    LIGHT_GREY: '#efefef',
    GRAY: 'rgba(0, 0, 0, 0.54)',
    DARK_GREY: '#2E2E2E',
  },
  'acai-brasil': {
    BASE: '#5B1A34',
    PRIMARY_BACKGROUND: '#F8F4EB',
    ACCENT: '#F8F4EB',
    SECONDARY_MAIN: '#27352E',
    WHITE: '#fff',
    LIGHT_GREY: '#efefef',
    GRAY: 'rgba(0, 0, 0, 0.54)',
    DARK_GREY: '#27352E',
  },
  'la-condesa': {
    BASE: '#1B5B75',
    PRIMARY_BACKGROUND: '#f7eedd',
    ACCENT: '#fff',
    SECONDARY_MAIN: '#fff',
    WHITE: '#fff',
    LIGHT_GREY: '#EFEFEF',
    GRAY: 'rgba(0, 0, 0, 0.54)',
    DARK_GREY: '#2E2E2E',
  },
  'el-diez': {
    BASE: '#1B5B75',
    PRIMARY_BACKGROUND: '#F8F4EB',
    ACCENT: '#F8F4EB',
    SECONDARY_MAIN: '#27352E',
    WHITE: '#fff',
    LIGHT_GREY: '#EFEFEF',
    GRAY: 'rgba(0, 0, 0, 0.54)',
    DARK_GREY: '#27352E',
  },
}

// Definir un tema por defecto
const DEFAULT_THEME: ColorTheme = COLOR_THEMES.ge

// Obtener el tema según la aplicación o usar el tema por defecto
const COLORS: ColorTheme =
  COLOR_THEMES[process.env.REACT_APP_NAME?.toLowerCase() || 'ge'] || DEFAULT_THEME

export { COLORS }
